<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>
<style lang="scss">
    @import './style/common';
    html,body{
      width:100%;
      height:100%;
    }
    #app{
      width:100%;
      height:100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue